export enum WheelAttrType {
  ADDRESS_REQUIRED = 'ADDRESS_REQUIRED'
}
